<template>
  <div class="main_box">

    <div class="main_box_wx" v-if="!phone">
        <h1>欢迎登录</h1>

        <div class="wx_login_btn" @click="wxlogin()">
            <img src="https://cdncos.aigupiao.com/assets/pc/img/2023/js_wx.svg" alt="">
            微信登录
        </div>


        <div class="split">
            <i></i>
            <span>其他登录方式</span>
            <i></i>
        </div>


        <div class="change_way">
            <img @click="phone = true" src="https://cdncos.aigupiao.com/assets/pc/img/2023/jf_sd.svg" alt="">
            <p>手机号登录</p>
        </div>


    </div>

    <div class="main_box_sj" v-show="phone">

        <h1>欢迎登录</h1>


        <div class="change_phone">
            <span :class="[pass ? 'chosed' : '']" @click="pass = true;">密码登录</span>
            <span :class="[!pass ? 'chosed' : '']" @click="pass = false;">验证码登录</span>
        </div>


        <div class="phone_box phone_pass" v-show="pass">

            <form :action="'https://mobile'+current+'.aigupiao.com/login/loging_form'" id="login-form" method="post">
                <input v-model="pass_name" type="text"  name="username"  class="up" placeholder="用户名/手机号">

                <input v-model="pass_word" type="password"  name="password"  data="passwordtype" placeholder="密码">

                <input type="hidden" name="redirect" v-model="redirect">
            </form>

        </div>


        <div class="phone_box phone_not" v-show="!pass">

            <form :action="'https://mobile'+current+'.aigupiao.com/login/sms_code_login'" id="login-form2" method="post">

                

                <input v-model="phone_number" type="text" class="up" placeholder="手机号" name="phone">

                <div class="verify">
                    <input v-model="phone_ve" type="text" placeholder="验证码" name="sms_code">

                    <span @click="sendCode()">
                        {{ !send_again ? '获取验证码' : ( time > 0 ?  time+'秒后重新获取' : '重新获取') }}
                    </span>
                </div>


                <input type="hidden" name="redirect" v-model="redirect">

        </form>



        </div>


        <div class="login_btn not" 
            @click="login_phone"

        :class="[
             
            (
                (pass && pass_name && pass_word)||
                (!pass && phone_number && phone_ve)
        
            ) 
                
                 ? 'login_btn_yes' : '']">登录</div>

        <p v-if="!pass">未注册手机号，登录将自动注册</p>

        <div class="split">
            <i></i>
            <span>第三方登录</span>
            <i></i>
        </div>

        

        <div class="change_way">
            <img @click="phone = false" src="https://cdncos.aigupiao.com/assets/pc/img/2023/js_wx2.svg" alt="">
            <p>微信登录</p>
        </div>

        

    </div>


  </div>
</template>

<script>
import { Toast, Dialog } from 'vant';
export default {
    data(){
        return {
            phone: false,
            pass:true,

            pass_name:'',
            pass_word:'',
            phone_number:'',
            phone_ve:'',

            current:'',
            redirect:'',

            send_again:false,

            time:0,
            Interval:null,
            set_time:59,
        }
    },
    created(){
        if(location.origin.indexOf("dev") > -1 || location.origin.indexOf("8080") > -1) {
            this.current = "dev"
        }
        else if(location.origin.indexOf("beta") > -1) {
            this.current = "beta"
        }
        this.redirect = window.location.search ? window.location.search.substring(1).substring(9) : '';
    },
    methods:{
        wxlogin(){
            //微信登录  
            let url = `/login/wx_login.html?${window.location.search.substring(1)}`;
            console.log('url',url);
            location.href = url;
        },
        login_phone(){

            if(this.pass && this.pass_name && this.pass_word){
                //账号手机号密码登录

                $.ajax({
                    xhrFields: {withCredentials: true},
                    type: 'post',
                    url: `https://mobile${this.current}.aigupiao.com/login/loging_check`,
                    data:{
                        'username':this.pass_name,
                        'password':this.pass_word,
                    },
                    dataType: 'json',
                    cache: false,
                    async: false,
                    beforeSend:function (XMLHttpRequest) {},
                    error: function(){return false;},
                    success:function(d){
                        if(d.rslt == 'succ'){


                            $("#login-form").submit();


                            // $.ajax({
                            //     type: 'post',
                            //     url: `https://mobile${current}.aigupiao.com/login/loging_form`,
                            //     data:{
                            //         'username':username,
                            //         'password':password,
                            //     },
                            //     //dataType: 'json',
                            //     cache: false,
                            //     async: false,
                            //     beforeSend:function (XMLHttpRequest) {},
                            //     error: function(){return false;},
                            //     success:function(res){
                            //         if(res.rslt == 'succ'){
                            //             //跳转
                            //             location.href = window.location.search.substring(1);
                            //         }else{
                            //             Toast({
                            //                 type: "html",
                            //                 message: `<div class='jfLoginTips'>${res.info}</div>`,
                            //                 position: "middle"
                            //             })
                            //         }
                            //     }
                            // });


                        }else{
                            Toast({
                                type: "html",
                                message: `<div class='jfLoginTips'>${d.info}</div>`,
                                position: "middle"
                            })
                        }
                    }
                });


            }
            else if(!this.pass && this.phone_number && this.phone_ve){
                //验证码登录 调用接口

                if(!this.phone_number || !/^(13[0-9]|14[0-9]|15[0-9]|17[0-9]|18[0-9])\d{8}$/i.test(this.phone_number)){
                    Toast({
                        type: "html",
                        message: `<div class='jfLoginTips'>请输入正确的手机号</div>`,
                        position: "middle"
                    })
                    return ;
                }

                $.ajax({
                    xhrFields: {withCredentials: true},
                    type: 'post',
                    url: `https://mobile${this.current}.aigupiao.com/login/sms_code_login_check`,
                    data:{
                        'sms_code':this.phone_ve,
                        phone:this.phone_number,
                    },
                    dataType: 'json',
                    cache: false,
                    async: false,
                    beforeSend:function (XMLHttpRequest) {},
                    error: function(){return false;},
                    success:function(d){
                        if(d.rslt == 'succ'){
                            $("#login-form2").submit();

                        }else{
                            Toast({
                                type: "html",
                                message: `<div class='jfLoginTips'>${d.info}</div>`,
                                position: "middle"
                            })
                        }
                    }
                })



                // 验证码登录接口：https://mobiledev.aigupiao.com/login/sms_code_login
                // 请求方式：post
                // 参数：
                //     phone			//手机号
                //     sms_code		//验证码

                // $.ajax({
                //     type: 'post',
                //     url: `https://mobile${this.current}.aigupiao.com/login/sms_code_login`,
                //     data:{
                //         'sms_code':this.phone_ve,
                //         phone:this.phone_number,
                //     },
                //     dataType: 'json',
                //     cache: false,
                //     async: false,
                //     beforeSend:function (XMLHttpRequest) {},
                //     error: function(){return false;},
                //     success:function(res){
                //         console.log('res',res)
                //         if(res.rslt == 'succ'){
                //             //跳转
                //             location.href = window.location.search.substring(1);
                //         }else{
                //             Toast({
                //                 type: "html",
                //                 message: `<div class='jfLoginTips'>${res.info}</div>`,
                //                 position: "middle"
                //             })
                //         }
                //     }
                // });
            }
        },
        sendCode(){
            if(!this.phone_number || !/^(13[0-9]|14[0-9]|15[0-9]|17[0-9]|18[0-9])\d{8}$/i.test(this.phone_number)){
                Toast({
                    type: "html",
                    message: `<div class='jfLoginTips'>请输入正确的手机号</div>`,
                    position: "middle"
                })
                return ;
            }
            this.send_again = true;

            if(!this.Interval){
                console.log('重复发送了吗？')
                this.time = this.set_time;
                //调用发送接口
                // https://apidev.aigupiao.com/v1/sms/send_code
                // 请求方式：post
                // 参数：
                // phone				//手机号
                // sms_code_type		//传 quick_login 
                // source				//传 wap

                let _this = this;
                $.ajax({
                    type: 'post',
                    url: `https://api${this.current}.aigupiao.com/v1/sms/send_code`,
                    data:{
                        'sms_code_type':'quick_login',
                        'source':'wap',
                        phone:this.phone_number,
                    },
                    dataType: 'json',
                    cache: false,
                    async: false,
                    beforeSend:function (XMLHttpRequest) {},
                    error: function(){return false;},
                    success:function(d){
                        if(d.status == 'success'){
                            Toast({
                                type: "html",
                                message: `<div class='jfLoginTips'>验证码已发送</div>`,
                                position: "middle"
                            });
                            _this.sendFn();
                        }else{
                            Toast({
                                type: "html",
                                message: `<div class='jfLoginTips'>${d.message}</div>`,
                                position: "middle"
                            })
                        }
                    }
                });
            }

        },
        sendFn(){
            this.Interval = setInterval(() => {
                this.time -- ;
                if(this.time == 0){
                    clearInterval(this.Interval);
                    this.Interval = null;
                }
            }, 1000);
        }
    }
}
</script>

<style lang="scss" scoped>
.main_box{
    min-height: 100vh;
    background: #fff;

    display: flex;
    flex-direction: column;
    align-items: center;


    .split{
        display: flex;
        height: 18px;
        align-items: center;
        justify-content: center;
        margin-bottom: 30px;
        >i{
            width: 60px;
            height: 1px;
            background: #EBEBEB;
            display: inline-block;
        }
        >span{
            font-size: 13px;
            line-height: 18px;
            color:#939393;
            margin: 0 10px;
        }
    }

    .change_way{
        
        display: flex;
        flex-direction: column;
        align-items: center;
        >p{

            font-size: 13px;
            text-align: center;
            color:#636363;
        }

        >img{
            width: 40px;
            height: 40px;
            margin: 0 auto 10px;
            display: flex;
        }
    }

    .main_box_wx{
        >h1{
            font-weight: 500;
            font-size: 30px;
            line-height: 100%;
            text-align: center;
            margin: 100px 0 120px;
        }

        .wx_login_btn{
            width: 280px;
            height: 44px;
            border-radius: 100px;
            background: #FF443D;
            box-shadow: 0px 2px 4px -2px #0000001A;
            box-shadow: 0px 4px 6px -1px #0000001A;
            color: #FFFFFF;
            margin-bottom: 180px;
            font-weight: 500;
            font-size: 15px;
            display: flex;
            align-items: center;
            justify-content: center;
            >img{
                width: 25px;
                height: 25px;
                margin-right: 8px;
            }

        }





    }

    .main_box_sj{
        padding: 0 30px;
        width: 100%;
        box-sizing: border-box;
        >h1{
            font-weight: 500;
            font-size: 26px;    
            line-height: 28px;
            margin: 50px 0 40px;

        }
        .change_phone{
            margin-bottom: 35px;
            span{
                color:#CACACA;
                margin-right: 22px;
                font-weight: 400;
                font-size: 18px;
            }
            .chosed{
                color:#333333;
            }
        }

        .phone_box{
            margin-bottom: 25px;
            input{
                width: 100%;
                height: 45px;
                font-size: 18px;
                line-height: 45px;
                border-bottom: .5px solid #939393;
                color: #333;


                &.up{
                    margin-bottom: 25px;
                }


                ::-webkit-input-placeholder { color:#CACACA; }
                ::-moz-placeholder { color:#CACACA; } /* firefox 19+ */
                :-ms-input-placeholder { color:#CACACA; } /* ie */
                input:-moz-placeholder { color:#CACACA; }
            }

            .verify{
                border-bottom: .5px solid #939393;
                width: 100%;
                height: 45px;
                display: flex;
                align-items: center;
                justify-content: space-between;

                border-bottom: .5px solid #939393;

                >input{
                    border: none;
                    width: 60%;
                }
                span{
                    font-weight: 400;
                    font-size: 15px;
                    text-align: right;
                    color: #333;
                }
            }
        }
        >p{
            color: #939393;
            text-align: center;
            margin: -70px 0 50px;
        }

        .login_btn{
            background: #CACACA;
            width: 315px;
            height: 42px;
            border-radius: 100px;
            font-weight: 500;
            font-size: 15px;
            display: flex;
            align-items: center;
            justify-content: center;
            color: #F9F9F9;
            margin-bottom: 100px;
            &.login_btn_yes{
                background:#FE484A;
            }

        }
    }
}
</style>
